/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type RequestMedicalRecordsResponseDto = {
    referralId?: string;
    status: RequestMedicalRecordsResponseDto.status;
    reason?: string;
}

export namespace RequestMedicalRecordsResponseDto {

    export enum status {
        REGISTERED = 'registered',
        REJECTED = 'rejected',
        TRY_AGAIN = 'try_again',
    }


}
